const slidein = () => {

  jQuery(document).ready(function($){

    const $sidebar = $('.c-slidein-nav'),
          $html = $('html'),
          $body = $('body');

    $body.addClass('c-slidein-nav--body');

    const closeSideNav = function() {
      $sidebar.removeClass('--active');
      $html.removeClass('c-slidein-nav--html');
      $body.removeClass('c-slidein-nav--body__active');
    };

    const openSideNav = function() {
      $sidebar.addClass('--active');
      $html.addClass('c-slidein-nav--html');
      $body.addClass('c-slidein-nav--body__active');
    };

    /**
     * close sidenav on body click
     */
    $(document).on('click','.c-slidein-nav--body__active', function(e) {

      if (e.target !== this) {
        return;
      }

      closeSideNav();

    });

    $(document).on('click','.c-navigation__nav_toggle',function (e) {

      e.preventDefault();

      openSideNav();

    });

    $(document).on('click','.c-slidein-nav__close',function (e) {

      e.preventDefault();

      closeSideNav();

    });



    $(document).on('click','.c-slidein-nav__main__menu__item__toggle', function (e) {

      e.preventDefault();

      const $this = $(this),
            submenuID = $this.data('submenu'),
            $submenu = $('.c-slidein-nav__main__menu__sub[data-submenu="'+submenuID+'"]');

      $this.toggleClass('--active');
      $submenu.toggleClass('--active');

    });

  });

};

export default slidein;
